<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioPresentation from './AudioPresentation.vue';
import {
  getAudioAppearance,
  getAudioAvatarIdentity,
  isForwardedAudio,
} from './audioIdentity';
import { useMessageContext } from '../provider.js';
import { useMapGetter } from 'dashboard/composables/store';
import { ORIENTATION } from '../constants';

const {
  attachments,
  sender,
  orientation,
  contentAttributes,
  conversationId,
  inboxId,
} = useMessageContext();

const conversationGetter = useMapGetter('getConversationById');
const inboxGetter = useMapGetter('inboxes/getInbox');

const attachment = computed(() => attachments.value[0]);
const isOutgoing = computed(() => orientation.value === ORIENTATION.RIGHT);
const isForwarded = computed(() => isForwardedAudio(contentAttributes.value));

const avatarIdentity = computed(() =>
  getAudioAvatarIdentity({
    contentAttributes: contentAttributes.value,
    sender: sender.value,
    inbox: inboxGetter.value(inboxId.value) || {},
    conversation: conversationGetter.value(conversationId.value),
    isOutgoing: isOutgoing.value,
  })
);

const avatarName = computed(() => avatarIdentity.value.name);
const avatarSrc = computed(() => avatarIdentity.value.src);
const audioAppearance = computed(() =>
  getAudioAppearance({
    contentAttributes: contentAttributes.value,
    isOutgoing: isOutgoing.value,
  })
);
</script>

<template>
  <BaseBubble
    class="relative bg-transparent"
    data-bubble-name="audio"
    hide-meta
    hide-sender-name
  >
    <AudioPresentation
      :attachment="attachment"
      :appearance="audioAppearance"
      :is-outgoing="isOutgoing"
      :avatar-name="avatarName"
      :avatar-src="avatarSrc"
      :forwarded="isForwarded"
    />
  </BaseBubble>
</template>
